import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { AngularFireModule } from '@angular/fire';
//import { AngularFireAuthModule } from '@angular/fire/auth';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
//import { AgmCoreModule } from '@agm/core';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxSpinnerModule } from 'ngx-spinner';

import { LayoutService } from '@shared/services/layout.service';
import { ConfigService } from '@shared/services/config.service';
import { SpinnerService } from '@core/spinner/spinner.service';

import { SharedModule } from '@shared/shared.module';
import { AppComponent } from './app.component';
import { ContentLayoutComponent } from '@layouts/content/content-layout.component';
import { FullLayoutComponent } from '@layouts/full/full-layout.component';
import { TopLayoutComponent } from '@layouts/top/top-layout.component';

import { AuthService } from '@auth/auth.service';
import { AuthGuard } from '@auth/auth-guard.service';
import { WINDOW_PROVIDERS } from '@shared/services/window.service';
import { RoutesModule } from './routes/routes.module';
import { CoreModule } from '@core/core.module';
import { AuthRequestInterceptor } from '@auth/auth-request.interceptor';
import { AuthResponseInterceptor } from '@auth/auth-response.interceptor';
import Configs from '@shared/constants/configs';

const firebaseConfig = {
  apiKey: 'YOUR_API_KEY', //YOUR_API_KEY
  authDomain: 'YOUR_AUTH_DOMAIN', //YOUR_AUTH_DOMAIN
  databaseURL: 'YOUR_DATABASE_URL', //YOUR_DATABASE_URL
  projectId: 'YOUR_PROJECT_ID', //YOUR_PROJECT_ID
  storageBucket: 'YOUR_STORAGE_BUCKET', //YOUR_STORAGE_BUCKET
  messagingSenderId: 'YOUR_MESSAGING_SENDER_ID', //YOUR_MESSAGING_SENDER_ID
  appId: 'YOUR_APP_ID', //YOUR_APP_ID
  measurementId: 'YOUR_MEASUREMENT_ID' //YOUR_MEASUREMENT_ID
};


/*const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};*/

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({ declarations: [
        AppComponent,
        FullLayoutComponent,
        ContentLayoutComponent,
        TopLayoutComponent,
    ],
    bootstrap: [AppComponent], imports: [SharedModule,
        BrowserAnimationsModule,
        //AngularFireModule.initializeApp(firebaseConfig),
        //AngularFireAuthModule,
        NgbModule,
        NgxSpinnerModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        /*AgmCoreModule.forRoot({
          apiKey: 'YOUR_GOOGLE_MAP_API_KEY'
        }),**/
        //PerfectScrollbarModule,
        CoreModule,
        RoutesModule], providers: [
        AuthService,
        AuthGuard,
        LayoutService,
        ConfigService,
        SpinnerService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthRequestInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthResponseInterceptor,
            multi: true
        },
        WINDOW_PROVIDERS,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}


// print out version
/*console.log(`
[APP] name: ${Configs.appName}
[APP] ver: ${ Configs.version}
`);*/
